
(function () {
  // State
  const state = {
    currentStep: 1,
    totalSteps: 3,
    heightUnit: 'cm',
    weightUnit: 'kg',
    measurementUnit: 'cm',
    data: {
      height: null,
      weight: null,
      age: null,
      waist: null,
      hips: null,
      fitPreference: 3,
      braSystem: '',
      braBand: '',
      braCup: ''
    }
  };


  // DOM elements
  const wizard = document.querySelector('.wizard');
  const steps = document.querySelectorAll('.step');
  const btnBack = document.getElementById('btnBack');
  const btnClose = document.getElementById('btnClose');
  const btnNext = document.getElementById('btnNext');
  const summaryOverlay = document.getElementById('summaryOverlay');
  const summaryClose = document.getElementById('summaryClose');
  const btnEdit = document.getElementById('btnEdit');
  const btnDelete = document.getElementById('btnDelete');
  const btnAdd = document.getElementById('btnAdd');
  const ageInput = document.getElementById('age');
  const ageChips = Array.from(document.querySelectorAll('.age-chip'));
  const fitSlider = document.getElementById('fitPreference');
  const fitLabel = document.getElementById('fitLabel');
  const fitOptionButtons = Array.from(document.querySelectorAll('.slider-label-btn'));

  let i18n = {};
  try {
    i18n = JSON.parse(wizard?.dataset.sizeChartI18n || '{}');
  } catch (error) {
    console.error('Failed to parse size chart translations:', error);
  }

  function t(key, fallback) {
    return i18n[key] || fallback;
  }

  // Fit labels
  const fitLabels = {
    1: 'МНОГО ВТАЛЕНА',
    2: 'ВТАЛЕНА',
    3: 'НОРМАЛНА',
    4: 'СВОБОДНА',
    5: 'МНОГО СВОБОДНА'
  };

  function getFitOptionValue(value) {
    const numericValue = Number(value) || 3;
    if (numericValue <= 2) return 1;
    if (numericValue >= 4) return 5;
    return 3;
  }

  function updateFitPreferenceUI(value) {
    const numericValue = Number(value) || 3;
    const normalizedValue = Math.max(1, Math.min(5, numericValue));
    const activeOptionValue = getFitOptionValue(normalizedValue);

    if (fitSlider) {
      fitSlider.value = normalizedValue;
    }
    if (fitLabel) {
      fitLabel.textContent = fitLabels[normalizedValue];
    }

    fitOptionButtons.forEach((button) => {
      const isActive = Number(button.dataset.fitValue) === activeOptionValue;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  const ageGroupLabels = {
    '12-17': '12-17',
    '18-39': '18-39',
    '40-59': '40-59',
    '60+': '60+'
  };

  function getAgeGroupFromValue(value) {
    if (value === null || value === undefined || value === '') return null;

    const stringValue = String(value).trim();
    if (ageGroupLabels[stringValue]) {
      return stringValue;
    }

    const numericValue = parseFloat(stringValue);
    if (Number.isNaN(numericValue)) return null;

    if (numericValue >= 60) return '60+';
    if (numericValue >= 40) return '40-59';
    if (numericValue >= 18) return '18-39';
    if (numericValue >= 12) return '12-17';
    return null;
  }

  function setAgeGroup(ageGroup) {
    const normalizedAgeGroup = getAgeGroupFromValue(ageGroup);

    if (ageInput) {
      ageInput.value = normalizedAgeGroup || '';
    }

    ageChips.forEach((chip) => {
      const isActive = chip.dataset.ageGroup === normalizedAgeGroup;
      chip.classList.toggle('active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    state.data.age = normalizedAgeGroup;
  }

  function getAgeGroupSummaryLabel(ageGroup) {
    const normalizedAgeGroup = getAgeGroupFromValue(ageGroup);
    return normalizedAgeGroup ? `Възрастова група ${normalizedAgeGroup}` : '';
  }


  function getSizeIndexFromRanges(value, ranges) {
    if (!value) return null;

    for (let i = 0; i < ranges.length; i++) {
      const [min, max] = ranges[i];
      const isLastRange = i === ranges.length - 1;

      if (value >= min && (value < max || (isLastRange && value <= max))) {
        return i;
      }
    }

    return null;
  }

  // Size recommendation logic
  function calculateSize() {
    // Values are already in canonical units (cm/kg) from collectData()
    const height = state.data.height || 170;
    const weight = state.data.weight || 65;
    const waist = state.data.waist || null;
    const hips = state.data.hips || null;
    const bust = parseFloat(state.data.braBand) || null;
    const ageGroup = getAgeGroupFromValue(state.data.age);

    let effectiveFit = state.data.fitPreference;
    if (ageGroup === '60+') {
      effectiveFit = Math.min(5, effectiveFit + 1); // Shift toward looser
    }
    // BMI calculation (height in cm, weight in kg)
    const heightM = height / 100;
    let bmi = weight / (heightM * heightM);

    // Age adjustment: older adults may need slightly larger sizes
    // at the same BMI due to different body composition
    if (ageGroup === '60+') {
      // Add a small adjustment for older adults
      // This shifts the effective BMI up slightly
      bmi = bmi * 1.03; // 3% adjustment
    } else if (ageGroup === '40-59') {
      bmi = bmi * 1.015; // 1.5% adjustment
    }

    let baseSize;
    if (bmi < 18.5) baseSize = 0;      // Size 34
    else if (bmi < 20) baseSize = 1;   // Size 36
    else if (bmi < 22) baseSize = 2;   // Size 38
    else if (bmi < 25) baseSize = 3;   // Size 40
    else if (bmi < 28) baseSize = 4;   // Size 42
    else if (bmi < 32) baseSize = 5;   // Size 44
    else baseSize = 6;                  // Size 46

    // EU size chart values from provided table image
    const bustRanges = [[80, 84], [84, 88], [88, 92], [92, 96], [96, 100], [100, 105], [105, 110]];
    const waistRanges = [[64, 68], [68, 72], [72, 76], [76, 80], [80, 84], [84, 89], [89, 94]];
    const hipRanges = [[86, 90], [90, 94], [94, 98], [98, 102], [102, 106], [106, 111], [111, 116]];

    let measurementSize = baseSize;

    const bustSize = getSizeIndexFromRanges(bust, bustRanges);
    if (bustSize !== null) {
      measurementSize = Math.max(measurementSize, bustSize);
    }

    const waistSize = getSizeIndexFromRanges(waist, waistRanges);
    if (waistSize !== null) {
      measurementSize = Math.max(measurementSize, waistSize);
    }

    const hipSize = getSizeIndexFromRanges(hips, hipRanges);
    if (hipSize !== null) {
      measurementSize = Math.max(measurementSize, hipSize);
    }

    // Blend BMI-based and measurement-based sizes
    if (bust || waist || hips) {
      baseSize = Math.round((baseSize + measurementSize) / 2);
    }

    // Fit preference adjustment (-2 to +2)
    const fitAdjustment = (effectiveFit || 3) - 3;
    baseSize = Math.max(0, Math.min(6, baseSize + Math.floor(fitAdjustment / 2)));

    const sizes = [34, 36, 38, 40, 42, 44, 46];
    return sizes[baseSize];
  }


  // Update step visibility
  function updateStep() {
    steps.forEach((step, idx) => {
      step.classList.toggle('active', idx + 1 === state.currentStep);
    });

    // Update back button visibility
    btnBack.style.visibility = state.currentStep === 1 ? 'hidden' : 'visible';

    // Update next button text
    if (state.currentStep === state.totalSteps) {
      btnNext.textContent = t('finish', 'ЗАВЪРШИ');
    } else {
      btnNext.textContent = t('next', 'НАПРЕД');
    }

    // Scroll to top
    window.scrollTo(0, 0);
  }

  // Validate current step
  function validateStep() {
    if (state.currentStep === 1) {
      const height = document.getElementById('height').value;
      const weight = document.getElementById('weight').value;
      return height && weight && parseFloat(height) > 0 && parseFloat(weight) > 0;
    }
    if (state.currentStep === 2) {
      const waist = document.getElementById('waist').value;
      const hips = document.getElementById('hips').value;
      return waist && hips && parseFloat(waist) > 0 && parseFloat(hips) > 0;
    }
    return true;
  }


  // Collect data from form
  function collectData() {
    // Get raw values from form
    let height = parseFloat(document.getElementById('height').value) || null;
    let weight = parseFloat(document.getElementById('weight').value) || null;

    if (height && state.heightUnit === 'ft') {
      height = height * 30.48; // feet to cm
    } else if (height && state.heightUnit === 'in') {
      height = height * 2.54; // inches to cm
    }
    if (weight && state.weightUnit === 'lb') {
      weight = weight * 0.453592; // lbs to kg
    }
    
    // Store in canonical units (always cm/kg)
    state.data.height = height;
    state.data.weight = weight;

    state.data.age = getAgeGroupFromValue(ageInput ? ageInput.value : null);

    // Get measurement values and convert to cm
    let waist = parseFloat(document.getElementById('waist').value) || null;
    let hips = parseFloat(document.getElementById('hips').value) || null;

    if (waist && state.measurementUnit === 'in') {
      waist = Math.round(waist * 2.54);
    }
    if (hips && state.measurementUnit === 'in') {
      hips = Math.round(hips * 2.54);
    }

    state.data.waist = waist;
    state.data.hips = hips;

    state.data.fitPreference = parseInt(fitSlider.value);
    state.data.braSystem = document.getElementById('braSystem').value;
    state.data.braBand = document.getElementById('braBand').value;
    state.data.braCup = document.getElementById('braCup').value;

    // Store units for display purposes
    state.data.heightUnit = state.heightUnit;
    state.data.weightUnit = state.weightUnit;
    state.data.measurementUnit = state.measurementUnit;
  }


  // Show summary
  function getSizeLabel(numericSize) {
    const mapping = {
      34: 'XS',
      36: 'S',
      38: 'M',
      40: 'L',
      42: 'XL',
      44: 'XXL',
      46: 'XXXL'
    };
    return mapping[Number(numericSize)] || '';
  }

  function showSummary() {
    collectData();
    const size = calculateSize();

    const sizeLabel = getSizeLabel(size);
    const sizeText = sizeLabel ? `${size} (${sizeLabel})` : `${size}`;

    document.getElementById('recommendedSize').textContent = sizeText;
    document.getElementById('addSizeLabel').textContent = sizeText;

    // Build summary details
    const details = [];

    if (state.data.height && state.data.weight) {
      const heightStr = `${state.data.height} ${state.data.heightUnit}`;
      const weightStr = `${state.data.weight} ${state.data.weightUnit}`;
      let line = `${heightStr} / ${weightStr}`;
      if (state.data.age) {
        line += ` / ${getAgeGroupSummaryLabel(state.data.age)}`;
      }
      details.push(line);
    }

    if (state.data.waist) {
      details.push(`Талия ${state.data.waist} ${state.data.measurementUnit}`);
    }

    if (state.data.hips) {
      details.push(`Ханш ${state.data.hips} ${state.data.measurementUnit}`);
    }

    details.push(`Настройка ${fitLabels[state.data.fitPreference].toLowerCase()}`);

    if (state.data.braBand && state.data.braCup) {
      details.push(`Размер на сутиена ${state.data.braBand} ${state.data.braCup}`);
    }

    document.getElementById('summaryDetails').innerHTML = details.map(d => `<p>${d}</p>`).join('');

    summaryOverlay.classList.add('active');
    // document.body.style.overflow = 'hidden';

    placeImage();
  }

  // Hide summary
  function hideSummary() {
    summaryOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Reset form
  function resetForm() {
    document.getElementById('height').value = '';
    document.getElementById('weight').value = '';
    setAgeGroup(null);
    document.getElementById('waist').value = '';
    document.getElementById('hips').value = '';
    document.getElementById('fitPreference').value = 3;
    document.getElementById('braSystem').value = '';
    document.getElementById('braBand').value = '';
    document.getElementById('braCup').value = '';

    updateFitPreferenceUI(3);

    state.currentStep = 1;
    state.data = {
      height: null,
      weight: null,
      age: null,
      waist: null,
      hips: null,
      fitPreference: 3,
      braSystem: '',
      braBand: '',
      braCup: ''
    };

    localStorage.removeItem('userSizeProfile');
    updateStep();
    hideSummary();
  }

  function closePage() {
    // Remove the side-panel-open class from body if it exists
    document.body.classList.remove('side-panel-open');

    // Try to find and click the side panel close button if it exists
    const button = document.querySelector('.side-panel-close');
    if (button) {
      button.click();
    } else {
      console.log('Side panel close button not found - this may be expected if side panel is not implemented');
    }
  }

  const STORAGE_KEY = 'userSizeProfile';
  const SIZE_RADIO_NAME = 'v1';
  const MESSAGES = {
    unavailable: t('unavailable', 'Размерът не е наличен за избрания продукт.'),
    closeConfirm: t('close_prompt', 'Искаш ли да прекратиш процеса и да се върнеш назад?')
  };

  const createProfile = (size) => {
    const profile = {
      ...state.data,
      recommendedSize: size,
      savedAt: new Date().toISOString()
    };
    localStorage.setItem('userSizeProfile', JSON.stringify(profile));
    return profile;
  };

  // Save to localStorage
  function saveData() {
    collectData();
    const size = calculateSize();
    const profile = createProfile(size);

    // Select the appropriate size radio button
    const input = document.querySelector(`input[type="radio"][name="${SIZE_RADIO_NAME}"][value="${size}"]`);

    if (input && !input.disabled) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      alert(MESSAGES.unavailable);
      if ( confirm(MESSAGES.closeConfirm) ) {
        closePage();
      }
      return;
    }

    closePage();
  }


  // Generate height options
  function generateHeightOptions(unit) {
    const select = document.getElementById('height');
    const currentValue = select.value;
    select.innerHTML = '<option value="">Изберете</option>';

    if (unit === 'cm') {
      for (let i = 140; i <= 205; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} CM`;
        select.appendChild(opt);
      }
    } else {
      // IN: roughly 55 to 81 inches (140-205 cm)
      for (let i = 55; i <= 81; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} IN`;
        select.appendChild(opt);
      }
    }

    // Try to restore value or convert
    if (currentValue) {
      if (unit === 'cm' && state.heightUnit === 'in') {
        select.value = Math.round(parseFloat(currentValue) * 2.54);
      } else if (unit === 'in' && state.heightUnit === 'cm') {
        select.value = Math.round(parseFloat(currentValue) / 2.54);
      } else {
        select.value = currentValue;
      }
    }
  }

  // Generate weight options
  function generateWeightOptions(unit) {
    const select = document.getElementById('weight');
    const currentValue = select.value;
    select.innerHTML = '<option value="">Изберете</option>';

    if (unit === 'kg') {
      for (let i = 40; i <= 120; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} KG`;
        select.appendChild(opt);
      }
    } else {
      // LBS: roughly 88 to 265 lbs (40-120 kg)
      for (let i = 88; i <= 265; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} LBS`;
        select.appendChild(opt);
      }
    }

    // Try to restore value or convert
    if (currentValue) {
      if (unit === 'kg' && state.weightUnit === 'lbs') {
        select.value = Math.round(parseFloat(currentValue) / 2.205);
      } else if (unit === 'lbs' && state.weightUnit === 'kg') {
        select.value = Math.round(parseFloat(currentValue) * 2.205);
      } else {
        select.value = currentValue;
      }
    }
  }

  // Generate waist options
  function generateWaistOptions(unit) {
    const select = document.getElementById('waist');
    const currentValue = select.value;
    select.innerHTML = '<option value="">Изберете</option>';

    if (unit === 'cm') {
      for (let i = 50; i <= 140; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} CM`;
        select.appendChild(opt);
      }
    } else {
      // IN: roughly 20 to 55 inches (50-140 cm)
      for (let i = 20; i <= 55; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} IN`;
        select.appendChild(opt);
      }
    }

    if (currentValue) {
      if (unit === 'cm' && state.measurementUnit === 'in') {
        select.value = Math.round(parseFloat(currentValue) * 2.54);
      } else if (unit === 'in' && state.measurementUnit === 'cm') {
        select.value = Math.round(parseFloat(currentValue) / 2.54);
      } else {
        select.value = currentValue;
      }
    }
  }

  // Generate hips options
  function generateHipsOptions(unit) {
    const select = document.getElementById('hips');
    const currentValue = select.value;
    select.innerHTML = '<option value="">Изберете</option>';

    if (unit === 'cm') {
      for (let i = 70; i <= 155; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} CM`;
        select.appendChild(opt);
      }
    } else {
      // IN: roughly 28 to 61 inches (70-155 cm)
      for (let i = 28; i <= 61; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = `${i} IN`;
        select.appendChild(opt);
      }
    }

    if (currentValue) {
      if (unit === 'cm' && state.measurementUnit === 'in') {
        select.value = Math.round(parseFloat(currentValue) * 2.54);
      } else if (unit === 'in' && state.measurementUnit === 'cm') {
        select.value = Math.round(parseFloat(currentValue) / 2.54);
      } else {
        select.value = currentValue;
      }
    }
  }


  // Event: Next button
  btnNext.addEventListener('click', () => {
    collectData();

    if (!validateStep()) {
      const validationMessages = {
        1: t('required_step1', 'Моля, попълнете задължителните полета (ръст и тегло).'),
        2: t('required_step2', 'Моля, попълнете задължителните полета (талия и ханш).')
      };
      alert(validationMessages[state.currentStep] || t('required_generic', 'Моля, попълнете задължителните полета.'));
      return;
    }

    if (state.currentStep < state.totalSteps) {
      state.currentStep++;
      updateStep();
    } else {
      showSummary();
    }
  });

  // Event: Back button
  btnBack.addEventListener('click', () => {
    if (state.currentStep > 1) {
      state.currentStep--;
      updateStep();
    }
  });

  // Event: Close button
  if (btnClose) {
    btnClose.addEventListener('click', () => {
      if (confirm(t('close_confirm', 'Сигурни ли сте, че искате да затворите?'))) {
        resetForm();
      }
    });
  }

  // Event: Summary close
  summaryClose.addEventListener('click', hideSummary);

  // Event: Edit button
  btnEdit.addEventListener('click', () => {
    hideSummary();
    state.currentStep = 1;
    updateStep();
  });

  // Event: Delete button
  btnDelete.addEventListener('click', () => {
    if (confirm(t('delete_confirm', 'Сигурни ли сте, че искате да изтриете данните?'))) {
      resetForm();
    }
  });

  // Event: Add button
  btnAdd.addEventListener('click', saveData);

  // Event: Unit toggles
  document.querySelectorAll('.toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      const unit = btn.dataset.unit;
      const group = btn.parentElement;

      group.querySelectorAll('.toggle-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      if (target === 'height') {
        generateHeightOptions(unit);
        state.heightUnit = unit;
      } else if (target === 'weight') {
        generateWeightOptions(unit);
        state.weightUnit = unit;
      } else if (target === 'measurements') {
        generateWaistOptions(unit);
        generateHipsOptions(unit);
        state.measurementUnit = unit;
      }
    });
  });

  // Event: Age group chips
  ageChips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const selectedAgeGroup = chip.dataset.ageGroup;
      const currentAgeGroup = getAgeGroupFromValue(ageInput ? ageInput.value : null);
      setAgeGroup(currentAgeGroup === selectedAgeGroup ? null : selectedAgeGroup);
    });
  });

  // Event: Clear buttons
  document.querySelectorAll('.input-clear').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.clear;
      document.getElementById(target).value = '';
    });
  });

  // Event: Fit slider
  fitSlider.addEventListener('input', () => {
    updateFitPreferenceUI(parseInt(fitSlider.value, 10));
  });

  // Event: Fit option labels
  fitOptionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selectedValue = parseInt(button.dataset.fitValue, 10);
      if (Number.isNaN(selectedValue)) return;
      updateFitPreferenceUI(selectedValue);
    });
  });


  // Load saved data on init
  function loadSavedData() {
    const saved = localStorage.getItem('userSizeProfile');
    if (saved) {
      try {
        const profile = JSON.parse(saved);
        if (profile.height) document.getElementById('height').value = profile.height;
        if (profile.weight) document.getElementById('weight').value = profile.weight;
        if (profile.age) setAgeGroup(profile.age);
        if (profile.waist) document.getElementById('waist').value = profile.waist;
        if (profile.hips) document.getElementById('hips').value = profile.hips;
        if (profile.fitPreference) {
          updateFitPreferenceUI(profile.fitPreference);
        }
        if (profile.braSystem) document.getElementById('braSystem').value = profile.braSystem;
        if (profile.braBand) document.getElementById('braBand').value = profile.braBand;
        if (profile.braCup) document.getElementById('braCup').value = profile.braCup;
      } catch (e) {
        console.error('Failed to load saved data:', e);
      }
    }
  }


  // Measurement modal
  const measurementModal = document.getElementById('measurementModal');
  const measurementModalClose = document.getElementById('measurementModalClose');
  const helpLink = document.querySelector('.help-link');

  // Function to close measurement modal
  function closeMeasurementModal() {
    measurementModal.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Open measurement modal
  if (helpLink) {
    helpLink.addEventListener('click', (e) => {
      e.preventDefault();
      measurementModal.classList.add('active');
      // document.body.style.overflow = 'hidden';
      // Focus the close button when modal opens
      setTimeout(() => {
        measurementModalClose.focus();
      }, 100);
    });
  }

  // Close measurement modal via button
  if (measurementModalClose) {
    measurementModalClose.addEventListener('click', closeMeasurementModal);
    
    // Close with Enter key when button is focused
    measurementModalClose.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        closeMeasurementModal();
      }
    });
  }

  // Close modal when clicking outside
  measurementModal.addEventListener('click', (e) => {
    if (e.target === measurementModal) {
      closeMeasurementModal();
    }
  });

  // Close modal with Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && measurementModal.classList.contains('active')) {
      closeMeasurementModal();
    }
  });


  // Initialize
  updateStep();
  setAgeGroup(null);
  loadSavedData();
  // Regenerate dropdowns with proper options based on current units
  generateHeightOptions(state.heightUnit);
  generateWeightOptions(state.weightUnit);
  generateWaistOptions(state.measurementUnit);
  generateHipsOptions(state.measurementUnit);
  updateFitPreferenceUI(parseInt(fitSlider.value, 10));
})();


function placeImage() {
  // Extract product image from the page
  const activeImageLink = document.querySelector('a[data-image].active') || 
                          document.querySelector('a[data-large]');
  let productImageUrl = '';

  if (activeImageLink) {
    // Use data-large for better quality, fallback to data-image
    productImageUrl = activeImageLink.dataset.large || 
                      activeImageLink.dataset.image || 
                      activeImageLink.querySelector('img')?.src || '';
  }

  // Update the summary image
  const summaryImageDiv = document.querySelector('.summary-image');
  if (productImageUrl && summaryImageDiv) {
    summaryImageDiv.innerHTML = `<img src="${productImageUrl}" alt="Product">`;
  } else {
    summaryImageDiv.innerHTML = '<span>Изображение</span>';
  }
}
